/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Toggle from '../../common/Toggle'
import ConfirmationModal2 from '../../common/ConfirmationModal2'
import moment from 'moment'
import DatePicker from '../../common/DatePicker'
import PropTypes from 'prop-types'
// CHILDREN
import TextInput from '../../common/form/TextInput'

// ASSETS
import './AdminUserForm.scss'

class AdminUserForm extends Component {
  constructor(props) { // eslint-disable-line complexity
    super(props)

    const user = props.user

    this.state = {
      id: user ? user.id : -1,
      first_name: user ? user.first_name : '',
      last_name: user ? user.last_name : '',
      username: user && user.username ? user.username : '',
      email: user && user.email ? user.email : '',
      gender: user ? user.gender : 'unselected',
      birthdate: user ? user.birthdate : null,
      family_id: user ? user.family_id : -1,
      type: user?.type || '',
      do_not_track: user ? user.do_not_track : false,
      pipedrive_person_id: user ? user.pipedrive_person_id || '' : '',
      showDeleteConfirmModal: false,
      bio: user?.bio || '',
      booking_url: user?.booking_url || '',
    }
  }

  validateForm = () => {
    const { family_id, type } = this.state

    if (type !== 'Representative' && !family_id) {
      return true
    }

    return false
  }

  handleChange = (event) => {
    const inputName = event.target.name
    const inputValue = event.target.value

    if (inputName === 'pipedrive_person_id' && inputValue < 0) {
      return
    }

    this.setState({
      [inputName]: inputValue,
    })
  }

  handleDoNotTrackChange = (event) => {
    this.setState({
      do_not_track: event.target.checked,
    })
  }

  handleTypeChange = (event) => {
    this.setState({ type: event.target.value })
  }

  isJuniorGolfer = () => Boolean(this.state.username) && !this.state.email

  _handleBirthdateChange = (date) => {
    this.setState({ birthdate: date })
  }

  handleShowDeleteConfirmModal = () => {
    this.setState({ showDeleteConfirmModal: true })
  }

  handleDeleteUser = () => {
    this.setState({ showDeleteConfirmModal: false })
    this.props.deleteUser(this.props.user)
  }

  render() {
    const { first_name, last_name, username, email, family_id, type, pipedrive_person_id, showDeleteConfirmModal, bio, booking_url } = this.state
    const {
      closeModal,
      updateUser,
      user,
      updateLoader,
      deleteLoader,
      t,
    } = this.props

    const actionLoading = updateLoader || deleteLoader

    let { birthdate } = this.state
    if (birthdate) {
      birthdate = moment(birthdate)
    }
    return (
      <div id='AdminUserForm'>
        <h4>{t('users.form.userDetails')}</h4>
        <div className='row'>
          <div className='col-md-6'>
            <label htmlFor='first_name'>{t('common.field.firstName')}</label>
            <input
              id='first_name'
              name='first_name'
              type='text'
              className='mb-3 form-control'
              label='First Name'
              placeholder={t('common.field.firstName')}
              value={first_name}
              readOnly
            />
          </div>
          <div className='col-md-6'>
            <label htmlFor='last_name'>{t('common.field.lastName')}</label>
            <input
              id='last_name'
              name='last_name'
              type='text'
              className='mb-3 form-control'
              label=''
              placeholder={t('common.field.lastName')}
              value={last_name}
              readOnly
            />
          </div>
        </div>
        {username && !email
          ? (
            <div className='row'>
              <div className='col-md-12'>
                <label htmlFor='username'>{t('common.field.username')}</label>
                <TextInput
                  id='username'
                  name={'username'}
                  type={'username'}
                  label={''}
                  value={username}
                  className='mb-3 form-control'
                  placeholder={''}
                  readOnly
                />
              </div>
            </div>
          ) : (
            <div className='row'>
              <div className='col-md-12'>
                <label htmlFor='email'>{t('common.field.email')}</label>
                <TextInput
                  id='email'
                  name={'email'}
                  type={'email'}
                  label={''}
                  value={email}
                  className='mb-3 form-control'
                  placeholder={''}
                  readOnly
                />
              </div>
            </div>
          )
        }

        {user?.oauth_external_id && (
          <div className='row'>
            <div className='col-md-12'>
              <label htmlFor='oauth_external_id'>{t('users.form.idpId')}</label>
              <input
                id='oauth_external_id'
                name='oauth_external_id'
                type='text'
                className='mb-3 form-control'
                value={user.oauth_external_id}
                readOnly
              />
            </div>
          </div>
        )}

        <div className='row'>
          <div className='col-md-6'>
            <label htmlFor='userType'>{t('users.form.typeLabel')}</label>
            <select
              id='userType'
              onChange={this.handleTypeChange}
              name='type'
              value={type}
              className='mb-3 form-control'
              disabled={this.isJuniorGolfer()}
            >
              <option value={'Coach'}>{t('users.form.userType.coach')}</option>
              <option value={'Student'}>{t('users.form.userType.student')}</option>
              <option value={'Representative'}>{t('users.form.userType.representative')}</option>
            </select>
          </div>
          <div className='col-md-6'>
            <label htmlFor='family_id'>{t('users.form.familyId')}*</label>
            <input
              id='family_id'
              name='family_id'
              type='number'
              className='mb-3 form-control'
              label=''
              onChange={this.handleChange}
              onWheel={(e) => e.target.blur()}
              placeholder={t('users.form.familyIdPlaceholder')}
              value={family_id}
            />
          </div>
        </div>
        <div className='row'>
          {type !== 'Representative' &&
            <div className='col-6 d-flex flex-column mb-3'>
              <label htmlFor='birthdateInput'>{t('common.field.birthdate')}</label>
              <DatePicker
                id='birthdateInput'
                selected={birthdate}
                onChange={this._handleBirthdateChange}
                disabled
              />
            </div>
          }
          {type === 'Coach' && (
            <div className='col-6 d-flex flex-column mb-3'>
              <label htmlFor='pipedrive_person_id'>{t('users.form.pipedrivePersonId')}</label>
              <TextInput
                id='pipedrive_person_id'
                name='pipedrive_person_id'
                type='number'
                value={pipedrive_person_id}
                onChange={this.handleChange}
                onWheel={(e) => e.target.blur()}
                placeholder={t('users.form.pipedrivePersonIdPlaceholder')}
              />
            </div>
          )}
        </div>
        {type === 'Representative' && (
          <>
            <div className='row'>
              <div className='col-6 d-flex flex-column mb-3'>
                <label htmlFor='calendarLink'>{t('users.form.calendarLink')}</label>
                <TextInput
                  name='booking_url'
                  id='calendarLink'
                  type='text'
                  value={booking_url}
                  onChange={this.handleChange}
                  onWheel={(e) => e.target.blur()}
                  placeholder={t('users.form.calendarLinkPlaceholder')} />
              </div>
              <div className='col-6 d-flex flex-column mb-3'>
                <label htmlFor='repBio'>{t('users.form.bio')}</label>
                <TextInput
                  name='bio'
                  id='repBio'
                  type='text'
                  value={bio}
                  onChange={this.handleChange}
                  onWheel={(e) => e.target.blur()}
                  placeholder={t('users.form.bioPlaceholder')} />
              </div>
            </div>
          </>
        )}
        <div className='row'>
          <div className='col-md-6 d-flex flex-column'>
            <label htmlFor='do_not_track'>{t('users.form.doNotTrack')}</label>
            <div className='pl-2'>
              <Toggle
                id='do_not_track'
                defaultChecked={user ? user.do_not_track : false}
                onChange={this.handleDoNotTrackChange}
              />
            </div>
          </div>
        </div>
        <div className='row mt-5'>
          <div className='col-md-4'>
            <button
              className='btn btn-dark m-2'
              onClick={closeModal}
              disabled={actionLoading}
            >
              {t('common.cancel')}
            </button>
          </div>
          <div className='col-md-4 d-flex justify-content-center align-items-center'>
            <button
              className='btn btn-primary m-2'
              onClick={() => updateUser(this.state)}
              disabled={
                actionLoading || this.validateForm()
              }
            >
              {updateLoader && (
                <i className='fa fa-spinner fa-spin light-loading-spinner' />
              )}
              {updateLoader ? t('users.form.updatingUser') : t('users.form.updateUser')}
            </button>
          </div>
          <div className='col-md-4'>
            <button
              className='float-right btn btn-primary btn-red m-2'
              onClick={this.handleShowDeleteConfirmModal}
              disabled={actionLoading}
            >
              {deleteLoader ? t('users.form.deletingUser') : t('users.form.deleteUser')}
            </button>
          </div>
        </div>
        {showDeleteConfirmModal && <ConfirmationModal2
          title={t('users.form.confirm.title')}
          message={t('users.form.confirm.message')}
          showModal={showDeleteConfirmModal}
          denyMessage={t('common.cancel')}
          proceedMessage={t('users.form.deleteUser')}
          type='delete'
          onDeny={() => this.setState({ showDeleteConfirmModal: false })}
          closeModal={() => this.setState({ showDeleteConfirmModal: false })}
          onProceed={this.handleDeleteUser}
        />}
      </div>
    )
  }
}

AdminUserForm.propTypes = {
  closeModal: PropTypes.func,
  formState: PropTypes.object,
  updateUser: PropTypes.func,
  deleteUser: PropTypes.func,
  loader: PropTypes.bool,
  updateLoader: PropTypes.bool,
  deleteLoader: PropTypes.bool,
  user: PropTypes.object,
  t: PropTypes.func,
}

export default withTranslation()(AdminUserForm)
